import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {SaleTaxComponent} from './saletax.component';

export const saleTaxRoutes: Routes = [
  {
    path: 'saletax',
    component: SaleTaxComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(saleTaxRoutes)],
  exports: [RouterModule]
})
export class SaleTaxRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/saletax/saletax-routing.module.ts